import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import logger from '../../../services/logger';

import { CareerRoadMapAnswers } from './career-roadmap-type';

export type CareerRoadMapAssessmentState = Partial<CareerRoadMapAnswers>;
const initialState: CareerRoadMapAssessmentState = {};

const careerRoadMapAssessmentSlice = createSlice({
  name: 'careerRoadMapAssssment',
  initialState: initialState,
  reducers: {
    update: (state, action: PayloadAction<CareerRoadMapAnswers>) => {
      logger.debug('Updating career-roadmap-assessment state.', {
        action,
        state,
      });
      Object.assign(state, { ...action.payload });
    },
  },
});

export const { update: updateCareerRoadMapAsessmentAction } = careerRoadMapAssessmentSlice.actions;
export default careerRoadMapAssessmentSlice.reducer;
